<template>
  <apexchart type="radialBar" :options="chartOptions" :series="series"></apexchart>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

// am4core.useTheme(am4themes_animated)

export default {
  name: 'radialPorcent',
  props: {
    serie: Number
  },
  data () {
    return {
      series: [this.serie],
      chartOptions: {
        chart: {
          type: 'radialBar',
          offsetY: -20
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: '#e7e7e7',
              strokeWidth: '97%',
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2
              }
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: -2,
                fontSize: '22px'
              }
            }
          }
        },
        colors: ['#009688'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          }
        },
        labels: ['Average Results']
      }
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  computed: {
  },
  methods: {}
}
</script>
